/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { PropsWithChildren } from 'react'
import { FiX } from 'react-icons/fi'
import ReactModal, { Props as ReactModalProps } from 'react-modal'

type ModalProps = PropsWithChildren<{
  isOpen: boolean
  onRequestClose: () => void
}>

const ReactModalComponent =
  ReactModal as unknown as React.ComponentType<ReactModalProps>

const ModalBox = ({
  isOpen,
  onRequestClose,
  children,
}: ModalProps): React.ReactElement => {
  return (
    <ReactModalComponent
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
    >
      <FiX onClick={onRequestClose} />
      {children}
    </ReactModalComponent>
  )
}

export default ModalBox
